import { useApiMutation } from "./use-api-mutation";

type UseAskAIFeedbackParams = {
	queryId: string;
	shopId: string;
	userIsOkWithAnswer: boolean;
};

export function useAskAIFeedback() {
	return useApiMutation("patch", "/shops/{shopId}/ask/{queryId}/feedback", {
		notify: { success: false },
		mapVariables: (data: UseAskAIFeedbackParams) => ({
			params: { path: { queryId: data.queryId, shopId: data.shopId } },
			body: { userIsOkWithAnswer: data.userIsOkWithAnswer },
		}),
	});
}
